import React from 'react';
import './about.css';
function about() {
    return (
        <div>
       
    <div class="grid">
       
      
       

      <div class="two">
          <section class=" all all1">
              <div class="box box1"></div>
              <h1 class="title">I Enjoy</h1>
              <p class="text0">love to drive long distances.</p>
          </section> <section class=" all all2">
                <div class="box box2"></div>
                <h1 class="title">Family</h1>
                <p class="text0">I adore weekends with a family barbecue.</p>
            </section>
            <section class=" all all3">
                    <div class="box box3"></div>
                    <h1 class="title">Play</h1>
                    <p class="text0">I love to play volleyball and guitar</p>
                </section>
      </div>

       
      
    </div>
        </div>
    )
}

export default about
